// Normalize breadcrumb text.
;(function () {
	'use strict'

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', replaceBreadcrumbBreaks)
	} else {
		replaceBreadcrumbBreaks()
	}

	function replaceBreadcrumbBreaks() {
		const breadcrumbs = document.querySelectorAll('.ui-bc ul, .nav--breadcrumb ul')

		breadcrumbs.forEach(nav => {
			const elements = nav.querySelectorAll('a, span')

			elements.forEach(el => {
				if (el.textContent.trim() === '/') return

				let html = el.innerHTML
				html = html.replace(/&lt;br&gt;/gi, ' - ')
				html = html.replace(/&lt;br\/&gt;/gi, ' - ')
				html = html.replace(/&lt;br \/&gt;/gi, ' - ')

				el.innerHTML = html
			})
		})
	}
})()
